/** Feature keys that unlock the full company dashboard sidebar. */
export const COMPANY_DASHBOARD_FEATURES = [
    'dashboard',
    'manage_employees',
    'manage_contractors',
    'benefits',
    'deductions',
    'time_off',
    'reports',
    'location_management',
    'billing',
    'user_management',
    'multi_company',
    'reseller',
    'branding',
    'manage_company',
    'run_payroll',
    'role_permissions',
];

/**
 * Prefer API FirmRole features. Do not force full access for Reseller —
 * Owner vs Staff is decided by FirmRole.
 */
export function featuresForCompanyContext(role, featuresFromApi) {
    if (Array.isArray(featuresFromApi) && featuresFromApi.length > 0) return featuresFromApi;
    return featuresFromApi || [];
}
